export const REWARDS_REFERENCE_PREFIX = 'REWARDS_REF'
